module.exports.APP_TITLE = "ULesson";
module.exports.APP_SHORT_TITLE = "ULesson";

module.exports.API_BASE_URL = 'https://api-mpq.ulesson.com/V1/';
// module.exports.API_BASE_URL = 'https://api2.juegogames.com/ULESSON-QUIZ-V3/';
// module.exports.API_BASE_URL = 'https://api-mpq.ulesson.com/V1/';
module.exports.BASE_PATH = '/';
module.exports.ACCESS_TOKEN_KEY = 'ULESSON-V1_ACCESS_TOKEN';
